import { toUint8Array } from '@/utils/uint8Array.js'
import { fromBase64Url } from '@/utils/base64Url.js'
import { toast as sonnerToast } from 'sonner'
import { computed, observable } from 'mobx'

// TODO: PWA notif manager + badges
export default class NotificationsStore {
  rootStore = null

  @observable accessor unreadCount = 10

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  init = async () => {
    if (!('Notification' in window)) return
    if (this.enabled || this.disabled) return
    if (this.fingerprint.isBot) return

    await Notification?.requestPermission()
    if (!this.enabled) {
      console.log('[Notifications] Disabled')

      return
    }

    console.log('[Notifications] Enabled, subscribing...')

    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.subscribe({
      applicationServerKey: toUint8Array(fromBase64Url(import.meta.env.VITE_VAPID_PUBKEY)),
      userVisibleOnly: true,
    })

    if (!(await this.api.subscribeToNotifications(subscription))) {
      console.error('[Notifications] Failed to subscribe')
    } else console.log('[Notifications] Subscribed')
  }

  get api() {
    return this.rootStore.apiStore
  }

  get fingerprint() {
    return this.rootStore.fingerprintStore
  }

  get enabled() {
    return Notification?.permission === 'granted'
  }

  get disabled() {
    return Notification?.permission === 'denied'
  }

  @computed
  get hasUnreadNotifications() {
    return this.unreadCount > 0
  }

  toast = (text, opt = {}) => sonnerToast.message(text, opt)

  toastSuccess = (text, opt = {}) => sonnerToast.success(text, opt)

  toastInfo = (text, opt = {}) => sonnerToast.info(text, opt)

  toastWarning = (text, opt = {}) => sonnerToast.warning(text, opt)

  toastError = (text, opt = {}) => sonnerToast.error(text, opt)

  toastPromise = (
    promise,
    opt = {
      error: '',
      loading: '',
      success: () => '',
    }
  ) => sonnerToast.promise(promise, opt)

  toastLoading = (text, opt = {}) => sonnerToast.loading(text, opt)

  dismissAllToasts = () => sonnerToast.dismiss()

  dismissToast = id => sonnerToast.dismiss(id)

  getToastHistory = () => sonnerToast.getHistory()
}
